
  import {Component, Vue, Prop} from "vue-property-decorator";
  import SimpleAppTable from "@/shared/AppTable/components/SimpleAppTable.vue";
  import {IApp} from "@/interfaces/app.interface";
  import {httpResource} from "@/resources/http.resource";
  import {IEventsLog} from "@/shared/EventsLog/interfaces/events-log.interface";

  @Component({
    components: {
      SimpleAppTable,
    }
  })
  export default class CorpEventsLog extends Vue {
    @Prop() corpId: number;
    loadingData = false;

    tableList = [];
    tableProps = [
      { prop: 'dateEvent', label: 'Дата', propType: IApp.SortingPropType.Date,  dateFormat: IApp.DateFormats.PrintedDateTimeFull},
      { prop: 'persName',  label: 'Пользователь', },
      { prop: 'eventName', label: 'Событие', },
    ];

    async mounted() {
      await this.getData();
    }

    async getData() {
      this.loadingData = true;
      let asyncAction = async () => {
        const action = IEventsLog.Action.MainEventsLog;
        const params = {
          tableId: 8,
          recId: this.corpId,
        } ;
        const {data: {result: { eventsLog } } } = await httpResource.httpAction({ action, params });
        this.tableList = eventsLog;
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
      this.loadingData = false;
    }
  }
